import * as React from "react";
const B3 = (props) => (
  <svg
    width={26}
    height={28}
    viewBox="0 0 26 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.3942 2.16419L2.86782 7.0776C0.454869 8.65289 0.454869 12.1785 2.86782 13.7538L10.3942 18.6672C11.7445 19.5549 13.9699 19.5549 15.3201 18.6672L22.809 13.7538C25.2094 12.1785 25.2094 8.6654 22.809 7.0901L15.3201 2.1767C13.9699 1.27653 11.7445 1.27653 10.3942 2.16419Z"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.86797 15.3542L4.85547 21.2178C4.85547 22.8056 6.0807 24.5059 7.58097 25.006L11.5692 26.3312C12.2568 26.5563 13.3945 26.5563 14.0947 26.3312L18.0829 25.006C19.5832 24.5059 20.8084 22.8056 20.8084 21.2178V15.4167"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5845 17.7546V10.2532"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default B3;
